module.exports = __webpack_public_path__ + "img/tutorial_eight_fr.4ca72719.png";